import React, { ReactNode } from "react";

interface DeployPageLayoutProps {
  deploymentAction: ReactNode;
  configuration: ReactNode;
  lowerContent?: ReactNode;
}

export const DeployPageLayout: React.FC<DeployPageLayoutProps> = ({
  deploymentAction,
  configuration,
  lowerContent,
}) => {
  return (
    <div className="w-full">
      <section aria-label="Launchable deployment action" className="w-full">
        {deploymentAction}
      </section>
      <section aria-label="Launchable configuration" className="w-full">
        {configuration}
      </section>

      {lowerContent && (
        <section
          aria-label="Launchable content"
          className="mt-8 min-w-0 rounded-lg border border-zinc-700 bg-secondaryBg/60 px-5 py-4 sm:px-6 sm:py-5"
        >
          {lowerContent}
        </section>
      )}
    </div>
  );
};
